import { type Address } from '../addresses/types.ts'
import { type AssetMedia, type BuildingType } from '../assets/assetDataTypes.ts'
import { type AssetRelationType } from '../assets/assetRelationTypes.ts'
import { type InterestAssetMatchScore } from '../interests/types.ts'

export const ownershipLevels = ['own', 'foreign', 'organisation'] as const
export type OwnershipLevel = (typeof ownershipLevels)[number]

export type LeadOrganisation = {
  id: string
  name: string
  logoMedia: AssetMedia | null
  realtorName: string | null
}

export type LeadInterestData = {
  locations?: { label?: string; postalCode?: string }[]
  filters?: {
    buildingTypes?: BuildingType[]
    sizeMin?: number | null
    sizeMax?: number | null
    priceMax?: number | null
    buildYearMin?: number | string | null
    roomsMin?: number | null
    roomsMax?: number | null
  }
}

export type LeadInterest = {
  id?: string
  created_at?: string | null
  data?: LeadInterestData | null
}

export type LeadTopMatchingAsset = {
  assetId: string
  assetName: string | null
  assetMedia: Array<{ url: string }> | null
  address: Address | null
  relationType: AssetRelationType
  matchScores: InterestAssetMatchScore
}

export type LeadListItemData = {
  id: string
  name: string
  created_at?: string
  updated_at?: string
  is_own?: boolean
  is_purchased?: boolean
  is_verified?: boolean
  organisation?: LeadOrganisation | null
  interest: LeadInterest
  media?: { url: string }[]
  matchScores?: InterestAssetMatchScore | null
  topMatchingAssets?: LeadTopMatchingAsset[]
  totalMatchingAssetsCount?: number
  totalFeedbackResponsesCount?: number
}
